import globals from "@src/assets/js/globals";
import _window from "@src/libraries/window";
import Vue from "@src/libraries/vue";
import { isProduction } from "@src/assets/js/utils";
import { moduleDebug } from "@src/assets/js/debug";
import routesStore from '@src/store/routes';
import usersStore from '@src/store/users';
const amplitudeInstance = new Promise(resolve => {
    if (!process.client) {
        resolve();
        return;
    }
    if (off()) {
        resolve();
        return;
    }
    import('amplitude-js').then(amplitudeImport => {
        const amplitudeInstance = amplitudeImport.default.getInstance();
        amplitudeInstance.init("f5bf59efcf41502b65c9103b24de90db");
        resolve(amplitudeInstance);
    });
});
const analytics = {
    async identify(data, id) {
        const ga = globals.ga;
        if (ga) {
            if (id)
                ga.set("userId", id);
            for (const key in data)
                ga.set(key, data[key]);
        }
        const amplitude = await amplitudeInstance;
        if (amplitude) {
            if (id)
                amplitude.setUserId(id);
            amplitude.setUserProperties(data);
        }
    },
    async page(page, data = {}) {
        fillData(data);
        const ga = globals.ga;
        if (ga) {
            let eventLabel = data && JSON.stringify(data);
            if (data && 1 === Object.values(data).length)
                eventLabel = Object.values(data)[0];
            ga.event({
                eventCategory: 'All',
                eventAction: `Viewed ${page} Page`,
                eventLabel
            });
        }
        const amplitude = await amplitudeInstance;
        if (amplitude) {
            await new Promise(function (resolve) {
                amplitude.logEvent(`Viewed ${page} Page`, data, resolve);
            });
        }
    },
    async track(event, data = {}) {
        const ga = globals.ga;
        if (ga) {
            let eventLabel = data && JSON.stringify(data);
            if (data && 1 === Object.values(data).length)
                eventLabel = Object.values(data)[0];
            ga.event({
                eventCategory: 'All',
                eventAction: event,
                eventLabel,
            });
        }
        const amplitude = await amplitudeInstance;
        if (amplitude)
            amplitude.logEvent(event, fillData(data));
    },
};
if (process.client) {
    let pathname = "";
    document.addEventListener('mousedown', e => pathname = location.pathname);
    document.addEventListener('touchstart', e => pathname = location.pathname);
    document.addEventListener('click', function (event) {
        const target = event.target;
        if (!target)
            return;
        const btn = target.closest("button") || target.closest("a") || target.closest(".v-chip");
        if (!btn)
            return;
        let buttonText = btn.getAttribute("alt");
        if (!buttonText) {
            const closestAlt = target.closest("[alt]");
            if (closestAlt)
                buttonText = closestAlt.getAttribute("alt") || "";
        }
        if (!buttonText) {
            console.log("!buttonText");
            return;
        }
        let pageName = pathname
            .replace(/\/[a-zA-Z]{2,3}(-[a-zA-Z]{2,3})?\/?/, "")
            .replace(/^\/|\/$/g, '')
            .split("/")[0];
        const data = {};
        if (btn.getAttribute("href"))
            data.href = btn.getAttribute("href");
        const li = btn.closest("li");
        let liText = (li === null || li === void 0 ? void 0 : li.getAttribute("alt")) || (li === null || li === void 0 ? void 0 : li.getAttribute("title")) || (li === null || li === void 0 ? void 0 : li.innerText);
        liText = liText && formatText(liText);
        if (liText)
            data.item = liText;
        analytics.track(`Clicked "${formatText(buttonText)}" in /${pageName}`, data);
    }, false);
}
function cleanData(data) {
    const clean = {};
    for (const key in data) {
        if ("object" == typeof data[key]) {
            data[key] = cleanData(data[key]);
        }
        else {
            clean[key] = data[key] || "";
        }
    }
    return clean;
}
function fillData(data) {
    if (!data.url)
        data.url = location.href;
    if (!data.path)
        data.path = location.pathname;
    if (!data.search)
        data.search = location.search;
    if (!data.referrer)
        data.referrer = document.referrer;
    if (!data.title)
        data.title = document.title;
    if (!data.page)
        data.page = routesStore.page;
    return data;
}
function formatText(str) {
    if (!str)
        return "";
    console.log("str", str);
    str = str.replace(/\$[0-9.,]*/, "");
    let strArr = str.split(/\n/).filter(s => isNaN(Number(s)));
    if (!strArr.length)
        strArr = str.split(/\n/);
    return strArr.join(" | ")
        .replace(/\s\s+/g, ' ')
        .trim();
}
function off() {
    if (!isProduction)
        return true;
    if (!process.client)
        return true;
    return false;
}
const analyticsStore = new Vue({
    computed: {
        routePage: () => routesStore.page,
        me: () => usersStore.me
    },
    watch: {
        me: {
            immediate: true,
            async handler(me, prevMe) {
                if (!process.client)
                    return;
                if (me) {
                    this.identify({
                        cordova: !!_window.cordova,
                        device: _window.device,
                        user: me
                    }, "" + me.id);
                }
            }
        },
        routePage: {
            immediate: true,
            async handler(routePage) {
                if (!process.client)
                    return;
                if (!routePage)
                    return;
                this.page(routePage);
            }
        }
    },
    methods: {
        async identify(data, id, callback) {
            if (off())
                return;
            await analytics.identify(cleanData(data), id);
            if (callback)
                callback();
        },
        async page(name, data, callback) {
            if (off())
                return;
            await analytics.page(name, cleanData(data));
            if (callback)
                callback();
        },
        async track(event, data, callback) {
            if (off())
                return;
            await analytics.track(event, cleanData(data));
            if (callback)
                callback();
        },
        async sendEvents() {
            const amplitude = await amplitudeInstance;
            if (amplitude === null || amplitude === void 0 ? void 0 : amplitude.sendEvents)
                await amplitude.sendEvents();
        }
    }
});
export default analyticsStore;
moduleDebug(analyticsStore);
